/**
 * Manage Constants in a single place
 */

export const KeyCodes = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  UP: 38,
  DOWN: 40
};

export const Events = {
  CLICK: 'click',
  KEYDOWN: 'keydown',
  RESIZE: 'resize',
  SCROLL: 'scroll',
  POPSTATE: 'popstate'
};

export const Intervals = {
  'RESIZE_INTERVAL': 50,
  'SCROLL_INTERVAL': 50
}

export const Distances = {
  // When elements controlled by scroll distance should be visible.
  'SCROLL_VISIBILITY_TRIGGER': 600
}
